import React, { memo, useEffect, useState } from 'react';
import { Ellipse, Rect, Text } from 'react-konva';
import WebFont from 'webfontloader';

const MarkElement = ({ element }: { element: GM.ReservesSchemas.SchemaMark }) => {
  const { x, y, angle, color, font, text, width, height } = element;
  const rgbaColor = `rgba(${color.r}, ${color.g}, ${color.b}, ${color.a})`;
  const [fontLoaded, setFontLoaded] = useState(false);

  // @todo Нужно решить как быть в подобных ситуациях
  // Из системы приходит шрифт Microsoft Sans Serif и его
  //   не получается ни загрузить, ни найти в системе. Поэтому стоит fallback
  //   на шрифт из нового дизайна.
  //   Добавлена загрузка шрифта через webfontloader. Неизвестно насколько это поможет
  useEffect(() => {
    WebFont.load({
      google: {
        families: [font.fontFamily],
      },
      active: () => setFontLoaded(true),
      // inactive: () => console.error(`Failed to load font: ${font.fontFamily}`),
    });
  }, [font.fontFamily]);

  return (
    <Text
      x={x + width / 2}
      y={y + height / 2}
      width={width}
      height={height}
      rotation={angle}
      offsetX={width / 2}
      offsetY={height / 2}
      fill={rgbaColor}
      text={text}
      fontFamily={fontLoaded ? font.fontFamily : 'Geologica, Arial, sans-serif'}
      fontStyle={fontLoaded ? font.fontStyle?.toLowerCase() : undefined}
      fontSize={font.size}
    />
  );
};

export const SchemaBasicElement = memo(function SchemaBasicElement({
  element,
}: {
  element:
    | GM.ReservesSchemas.SchemaMark
    | GM.ReservesSchemas.SchemaRectangle
    | GM.ReservesSchemas.SchemaEllipse;
}) {
  if (element.type === 'MARK') {
    return <MarkElement element={element} />;
  }

  const { x, y, width, height, angle, color } = element;
  const rgbaColor = `rgba(${color.r}, ${color.g}, ${color.b}, ${color.a})`;

  if (element.type === 'RECTANGLE') {
    return (
      <Rect
        x={x + width / 2}
        y={y + height / 2}
        width={width}
        height={height}
        rotation={angle}
        offsetX={width / 2}
        offsetY={height / 2}
        fill={rgbaColor}
      />
    );
  }

  if (element.type === 'ELLIPSE') {
    return (
      <Ellipse
        x={x + width / 2}
        y={y + height / 2}
        radiusX={width / 2}
        radiusY={height / 2}
        rotation={angle}
        offsetX={0}
        offsetY={0}
        fill={rgbaColor}
      />
    );
  }

  return null;
});
